// extracted by mini-css-extract-plugin
export default {"fieldWithIcon":"jut__FieldIcon__fieldWithIcon","iconWrapper":"jut__FieldIcon__iconWrapper","icon":"jut__FieldIcon__icon"};